import { Helmet } from 'react-helmet-async';
import Mainpage from './trade-work-title';
import { useEffect } from 'react';
import { useSearchParams } from 'src/routes/hooks';
// ----------------------------------------------------------------------
export default function TradeWorkTitlePage() {

    const searchParams = useSearchParams();
    const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
    const project = searchParams.get('project_id') || localStorage.getItem('projectId') || '';
    const company = searchParams.get('company_id') || localStorage.getItem('companyId') || '';
    useEffect(() => {
        localStorage.setItem('authToken', token);
        localStorage.setItem('projectId', project);
        localStorage.setItem('companyId', company);
    }, [ token ]);

    return (
        <>
            <Helmet>
                <title> Trade Work Title </title>
            </Helmet>
            <Mainpage />
        </>
    );
}
